(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-featured-projects-carousel').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 30,
				slidesPerView: 1,
				loop: false,

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				breakpoints: {
					1280: {
						spaceBetween: 40,
						slidesPerView: 2,
					},
				},
			});
		});
	});
})(jQuery, document, window);
